"use client";

import { Price } from "@repo/components/atoms/price";
import { cn } from "@repo/lib";
import { useCartQuery } from "#/hooks/shopify";

export function TotalAmount({
  cartId,
  className,
  lang,
}: {
  cartId?: string;
  className?: string;
  lang: Navigator["language"];
}) {
  const cart = useCartQuery(cartId);

  const totalAmount = cart?.cost?.totalAmount;

  if (!totalAmount) {
    return null;
  }

  return (
    <Price
      {...totalAmount}
      aria-live="polite"
      className={cn(
        "absolute mt-2 p-1 bg-accent text-accent-foreground opacity-0 pointer-events-none text-xs",
        "group-focus-within:opacity-100 group-hover:opacity-100",
        {
          "opacity-0": !totalAmount,
        },
        className,
      )}
      lang={lang}
      role="status"
      style={{
        positionAnchor: "--anchor-open-cart",
        insetBlockStart: "anchor(bottom)",
        insetInlineEnd: "anchor(right)",
      }}
    />
  );
}
